import { Button } from '@mui/material'
import React, { useState } from 'react'
import { CarPositionNode } from '../../../apollo/graphql/generated/types'
import { CarPositionModal } from '../../modals/CarPositionModal/CarPositionModal'
import styles from './CarPositionButton.module.scss'
import { t } from 'i18next'

interface CarPositionButtonProps {
  carId: string
  onPositionCreated?: (position: Partial<CarPositionNode>) => void
  initialData?: Partial<CarPositionNode>
  onSuccess?: () => void
}

export const CarPositionButton: React.FC<CarPositionButtonProps> = ({
  carId,
  onPositionCreated,
  initialData,
  onSuccess,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleSubmit = (position: Partial<CarPositionNode>) => {
    const positionWithCar = {
      ...position,
      car: carId,
    } as unknown as Partial<CarPositionNode>
    onPositionCreated?.(positionWithCar)
    setIsModalOpen(false)
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setIsModalOpen(true)}
        className={styles.button}
      >
        {t('add_position')}
      </Button>
      <CarPositionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
        initialData={initialData}
        carId={carId}
        onSuccess={onSuccess}
      />
    </>
  )
}
